import {Button} from 'antd'
import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default function PropertiesPaneButtonGenerateFm(props) {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()
    const nodes = [...selectedNodes].filter(n => n.data.pkid)

    if (0 === nodes.length) {
        return null
    }

    const onClick = () => {
        const {prjId, sVer} = map.data
        const dpIds = []
        const texts = []
        const BN = map.BizNode.FA

        for (const n of nodes) {
            dpIds.push(n.data.pkid)
            texts.push(BN.getTextRaw(map, n))
        }

        openWindow(
            '/Ai',

            {
                bizMap: {dpIds},
                prjId,
                scene: 'GENERATE_FA',
                sVer,
                title: `${BN.name}: ${texts.join(', ')}`,
            })
    }

    return (
        <Button
            onClick={onClick}
            {...props}
        >
            AI生成功能域
        </Button>
    )
}
